import React from "react";
import Footer from "../components/Footer";
import ServiceInfo from "../components/ServiceInfo";

function ServiceInfos() {
    
    return (
        <React.Fragment>
            <ServiceInfo/>
            <Footer />
        </React.Fragment>
    )
}

export default ServiceInfos